export default {
  state: {
    username: '',
    password: '',
    email: '',
    birthdate: '',
    city: '',
    geoId: -1,
    gender: 'm',
    searchGender: 'w',
    searchAgeRange: {
      min: 35,
      max: 65
    },
    termsAndConditions: false,
    privacyNotice: false,
    publicProfile: false,
    registrationFinished: false,
    promoter: '',
    affiliateId: '',
    accessToken: '',
    legacyLogin: true,
    utm: {},
    project: '',
    showInCard: true,
    showTitle: true,
    titleText: '',
    buttonText: '',
    testGroup: '',
    coupon: ''
  },
  mutations: {
    updateUsername (state, username) {
      state.username = username
    },
    updateEmail (state, email) {
      state.email = email
    },
    updateTermsAndConditions (state, termsAndConditions) {
      state.termsAndConditions = termsAndConditions
    },
    updatePrivacyNotice (state, privacyNotice) {
      state.privacyNotice = privacyNotice
    },
    updatePublicProfile (state, publicProfile) {
      state.publicProfile = publicProfile
    },
    updateGender (state, gender) {
      state.gender = gender
    },
    updateSearchGender (state, searchGender) {
      state.searchGender = searchGender
    },
    updateCity (state, city) {
      state.city = city
    },
    updateGeoId (state, geoId) {
      state.geoId = geoId
    },
    updateBirthdate (state, birthdate) {
      state.birthdate = birthdate
    },
    updatePassword (state, password) {
      state.password = password
    },
    updateSearchAgeRange (state, range) {
      state.searchAgeRange.min = range[0];
      state.searchAgeRange.max = range[1];
    },
    updateShowInCard (state, showInCard) {
      state.showInCard = showInCard;
    },
    updateShowTitle (state, showTitle) {
      state.showTitle = showTitle;
    },
    registrationFinished (state) {
      state.registrationFinished = true

      state.username = ''
      state.password = ''
      state.email = ''
      state.birthdate = ''
      state.geoId = ''
    },
    updateAccessToken (state, accessToken) {
      state.accessToken = accessToken
    },
    updateLegacyLogin (state, value) {
      state.legacyLogin = value
    },
    updatePromoter (state, value) {
      state.promoter = value
    },
    updateAffiliateId (state, value) {
      state.affiliateId = value
    },
    updateProject (state, project) {
      state.project = project
    },
    updateUtm (state, utm) {
      state.utm = utm
    },
    updateTitleText (state, titleText) {
      state.titleText = titleText
    },
    updateButtonText (state, buttonText) {
      state.buttonText = buttonText
    },
    updateTestGroup (state, testGroup) {
      state.testGroup = testGroup
    },
    updateCoupon (state, coupon) {
      state.coupon = coupon
    }
  }
}
